module.exports = __webpack_public_path__ + "img/montage-logo.cce37962.png";